import { useState, type MouseEvent } from 'react';
import { Popover, Stack } from '@mui/material';
import { MHMLabel, type MHMLabelProps } from './MHMLabel';
import { LabelInput, type LabelInputProps } from '../shared/LabelInput';
import { Edit } from '@mui/icons-material';
import { useTranslation } from '../../../contexts/TranslationContext';

type Props = MHMLabelProps & {
  labelInputProps: LabelInputProps;
};

export function MHMEditableLabel(props: Props) {
  const { label, labelInputProps, ...rest } = props;
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [chipEl, setChipEl] = useState<HTMLElement | null>(null);

  function openEditPopover(e: MouseEvent) {
    setChipEl(e.currentTarget as HTMLElement);
    setIsOpen(true);
  }

  function closeEditPopover() {
    setChipEl(null);
    setIsOpen(false);
  }

  return (
    <>
      <MHMLabel
        label={
          <Stack
            direction="row"
            flexWrap="nowrap"
            justifyContent="space-between"
            alignItems="center"
          >
            {label}
            <Edit
              fontSize="small"
              onClick={openEditPopover}
              color="primary"
              sx={{ ml: 1.26, mr: -0.75, cursor: 'pointer' }}
            />
          </Stack>
        }
        {...rest}
      />
      <Popover
        open={isOpen}
        anchorEl={chipEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={closeEditPopover}
        sx={{ mt: 1.25, ml: 3.5 }}
      >
        <LabelInput
          textFieldLabel={t('Edit label')}
          sx={{ p: 2, ...labelInputProps.sx }}
          {...labelInputProps}
        />
      </Popover>
    </>
  );
}
